import { Injectable } from '@angular/core';
import { AppHttpClient } from './app-http-client.service';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class TeachingFieldService {

  categoriesList = ["General", "Elementary", "EarlyChildhood","EarlyChildhoodSped", "CollaborativeSped"];

  constructor(
    public http : AppHttpClient,
    public util : UtilService
  ) { }

  getTeachingFields(){
    return this.http.get('teaching-fields');
  }

  createTeachingField(payload: any){
    return this.http.post('teaching-fields', payload);
  }

  updateTeachingField(payload: any){
    return this.http.put('teaching-fields', payload);
  }

  deleteTeachingField(params: any){
    return this.http.delete('teaching-fields', { params });
  }
}
